// Modified Header.js
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setIsMenuOpen(false);
  };

  const goToProductPage = (slug) => {
    if (slug) {
      navigate(`/san-pham/${slug}`);
    } else {
      navigate('/san-pham');
    }
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const goToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => scrollTo(id), 50);
    } else {
      scrollTo(id);
    }
  };

  return (
    <header className="header">
      <nav className="nav">
        <div className="logo" onClick={() => goToSection('home')}>
          <div className="logo-icon">
            <svg viewBox="0 0 50 50" className="memory-svg">
              {/* Khung ảnh polaroid */}
              <rect x="8" y="10" width="34" height="30" rx="2" className="frame-outer" />
              <rect x="11" y="13" width="28" height="20" className="frame-inner" />
              
              {/* Trái tim trong khung */}
              <path d="M25 20 C23 18, 21 18.5, 21 20.5 C21 23, 25 26, 25 26 C25 26, 29 23, 29 20.5 C29 18.5, 27 18, 25 20 Z" className="heart-icon" />
              
              {/* Hiệu ứng ánh sáng */}
              <circle cx="25" cy="25" r="20" className="glow-circle" />
              
              {/* Dấu cộng trang trí */}
              <circle cx="42" cy="15" r="3" className="plus-circle" />
              <line x1="42" y1="13" x2="42" y2="17" className="plus-line" />
              <line x1="40" y1="15" x2="44" y2="15" className="plus-line" />
            </svg>
          </div>
          <div className="logo-text">
            <span className="logo-main">Memory</span>
            <span className="logo-sub">Lamp</span>
          </div>
        </div>
        
        {/* Desktop Navigation */}
        <ul className="nav-links">
          <li><a href="#home" onClick={(e) => { e.preventDefault(); goToSection('home'); }}>Trang chủ</a></li>
          <li className="dropdown">
            <a href="#products" onClick={(e) => { e.preventDefault(); goToProductPage(null); }}>Sản phẩm</a>
            <ul className="dropdown-menu">
              <li><a onClick={() => goToProductPage('den-xong-tinh-dau')}>Đèn xông tinh dầu</a></li>
              <li><a onClick={() => goToProductPage('tinh-dau-thien-nhien')}>Tinh dầu thiên nhiên</a></li>
            </ul>
          </li>
          <li><a href="#story" onClick={(e) => { e.preventDefault(); goToSection('story'); }}>Câu chuyện</a></li>
          {/* <li><a href="#gallery" onClick={() => scrollTo('gallery')}>Bộ sưu tập</a></li> */}
          <li><a href="#benefits" onClick={(e) => { e.preventDefault(); goToSection('benefits'); }}>Lợi ích</a></li>
          <li><a href="#testimonials" onClick={(e) => { e.preventDefault(); goToSection('testimonials'); }}>Đánh giá</a></li>
        </ul>
        
        <button className="contact-btn" onClick={() => goToSection('contact')}>Liên hệ</button>
        
        {/* Mobile Menu Button */}
        <button className="mobile-menu-btn" onClick={toggleMenu}>
          <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </nav>
      
      {/* Mobile Navigation Menu */}
      <div className={`mobile-nav ${isMenuOpen ? 'active' : ''}`}>
        <ul className="mobile-nav-links">
          <li><a href="#home" onClick={(e) => { e.preventDefault(); goToSection('home'); }}>Trang chủ</a></li>
          <li><a href="#products" onClick={(e) => { e.preventDefault(); goToProductPage(null); }}>Sản phẩm</a></li>
          <li><a onClick={() => goToProductPage('den-xong-tinh-dau')}>&nbsp;&nbsp;- Đèn xông tinh dầu</a></li>
          <li><a onClick={() => goToProductPage('tinh-dau-thien-nhien')}>&nbsp;&nbsp;- Tinh dầu thiên nhiên</a></li>
          <li><a href="#story" onClick={(e) => { e.preventDefault(); goToSection('story'); }}>Câu chuyện</a></li>
          <li><a href="#gallery" onClick={(e) => { e.preventDefault(); goToSection('gallery'); }}>Bộ sưu tập</a></li>
          <li><a href="#benefits" onClick={(e) => { e.preventDefault(); goToSection('benefits'); }}>Lợi ích</a></li>
          <li><a href="#testimonials" onClick={(e) => { e.preventDefault(); goToSection('testimonials'); }}>Đánh giá</a></li>
          <li><a href="#contact" onClick={(e) => { e.preventDefault(); goToSection('contact'); }}>Liên hệ</a></li>
        </ul>
      </div>
    </header>
  );
};

export default Header;